<script setup lang="ts">
interface Props {
  paddingTop?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  direction?: 'column' | 'row';
}

const { paddingTop = 'xl', direction = 'column' } = defineProps<Props>();
</script>

<template>
  <div
    class="ui-page-shell"
    :class="[`ui-page-shell--pt-${paddingTop}`, `ui-page-shell--${direction}`]"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">
.ui-page-shell {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  height: 100%;
  box-sizing: border-box;
  min-height: 0;
  display: flex;

  &--column {
    flex-direction: column;
  }

  &--row {
    flex-direction: row;
  }

  &--pt-none {
    padding-top: 0;
  }

  &--pt-sm {
    padding-top: $space-sm;
  }

  &--pt-md {
    padding-top: $space-md;
  }

  &--pt-lg {
    padding-top: $space-lg;
  }

  &--pt-xl {
    padding-top: $space-xl;
  }
}
</style>
